import PropTypes from 'prop-types';

import { Link } from 'events/routes';
import ArrowLeft from '../icons/ArrowLeft';
import css from './index.module.scss';

const BackButton = (props) => {
  const { children, route, type } = props;
  const buttonProps = { ...props };
  const attrs = Object.keys(BackButton.defaultProps);
  attrs.forEach((attr) => {
    delete buttonProps[attr];
  });

  if (route) {
    return (
      <Link route={route}>
        <a className={css.root} {...buttonProps}>
          <ArrowLeft />
          {children}
        </a>
      </Link>
    );
  }
  /* eslint-disable react/button-has-type */
  return (
    <button className={css.root} {...buttonProps} type={type}>
      <ArrowLeft />
      {children}
    </button>
  );
};
BackButton.defaultProps = {
  route: false,
  type: 'button',
};
BackButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]).isRequired,
  route: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  type: PropTypes.string,
};
export default BackButton;
